<template>
  <div v-if="visible" class="mask" @click.self="$emit('close')">
    <div class="modal modal-lg">
      <button class="modal-close" @click="$emit('close')">×</button>
      <h3>积分明细</h3>
      <div class="tabs">
        <button class="tab-btn" :class="{ active: activeTab === 'all' }" @click="activeTab = 'all'">全部</button>
        <button class="tab-btn" :class="{ active: activeTab === 'consume' }" @click="activeTab = 'consume'">消耗</button>
        <button class="tab-btn" :class="{ active: activeTab === 'gain' }" @click="activeTab = 'gain'">获取</button>
      </div>
      <div class="record-filters">
        <input
          v-model.trim="keyword"
          class="record-search"
          type="text"
          placeholder="搜索标题/模型/时间"
        />
        <select v-model="selectedModel" class="record-select" v-if="false">
          <option value="">全部模型</option>
          <option v-for="model in modelOptions" :key="model" :value="model">{{ model }}</option>
        </select>
      </div>
      <div ref="recordList" class="record-list" @scroll="onListScroll">
        <div v-for="item in displayedRecords" :key="item.id" class="record-item">
          <div>
            <div>{{ item.title }} | {{ item.model }}</div>
            <small>{{ item.time }}</small>
          </div>
          <strong :class="{ plus: item.amount.indexOf('+') === 0 }">{{ item.amount }}</strong>
        </div>
        <div v-if="!displayedRecords.length" class="record-empty">暂无匹配记录</div>
        <div v-else-if="loadingMoreRemote" class="record-load-tip">加载中…</div>
        <div v-else-if="hasMore" class="record-load-tip">下滑加载更多…</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PointsRecordModal",
  props: {
    visible: { type: Boolean, default: false },
    records: { type: Array, default: () => [] },
    /** 服务端是否还有更早的流水（与父组件分页配合） */
    hasMoreRemote: { type: Boolean, default: false },
    loadingMoreRemote: { type: Boolean, default: false }
  },
  data() {
    return {
      activeTab: "all",
      keyword: "",
      selectedModel: "",
      visibleCount: 20
    };
  },
  computed: {
    modelOptions() {
      const set = new Set();
      (this.records || []).forEach(item => {
        const model = String((item && item.model) || "").trim();
        if (model) set.add(model);
      });
      return Array.from(set);
    },
    filteredRecords() {
      const keyword = this.keyword.toLowerCase();
      if (this.activeTab === "consume") {
        return this.records
          .filter(item => String(item.amount || "").trim().indexOf("-") === 0)
          .filter(item => this.matchKeyword(item, keyword))
          .filter(item => this.matchModel(item));
      }
      if (this.activeTab === "gain") {
        return this.records
          .filter(item => String(item.amount || "").trim().indexOf("+") === 0)
          .filter(item => this.matchKeyword(item, keyword))
          .filter(item => this.matchModel(item));
      }
      return this.records
        .filter(item => this.matchKeyword(item, keyword))
        .filter(item => this.matchModel(item));
    },
    displayedRecords() {
      return this.filteredRecords.slice(0, this.visibleCount);
    },
    hasMore() {
      if (this.visibleCount < this.filteredRecords.length) return true;
      return this.hasMoreRemote;
    }
  },
  watch: {
    visible(val) {
      if (val) this.resetLoadState();
    },
    activeTab() {
      this.resetLoadState();
    },
    keyword() {
      this.resetLoadState();
    },
    selectedModel() {
      this.resetLoadState();
    }
  },
  methods: {
    resetLoadState() {
      this.visibleCount = 20;
      this.$nextTick(() => {
        const el = this.$refs.recordList;
        if (el) el.scrollTop = 0;
      });
    },
    matchModel(item) {
      if (!this.selectedModel) return true;
      return String((item && item.model) || "") === this.selectedModel;
    },
    matchKeyword(item, keyword) {
      if (!keyword) return true;
      const text = [
        item && item.title,
        item && item.model,
        item && item.time,
        item && item.type,
        item && item.amount
      ]
        .map(v => String(v || ""))
        .join(" ")
        .toLowerCase();
      return text.indexOf(keyword) !== -1;
    },
    onListScroll() {
      const el = this.$refs.recordList;
      if (!el) return;
      const remain = el.scrollHeight - el.scrollTop - el.clientHeight;
      if (remain > 24) return;
      if (this.visibleCount < this.filteredRecords.length) {
        this.visibleCount += 20;
        return;
      }
      if (this.hasMoreRemote && !this.loadingMoreRemote) {
        this.$emit("load-more-remote");
      }
    }
  }
};
</script>

<style scoped>
.modal {
  position: relative;
}

.modal-close {
    position: absolute;
    right: 14px;
    top: 10px;
    width: 36px;
    height: 36px;
    border: none;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.06);
    color: #fff;
    font-size: 22px;
    line-height: 1;
    cursor: pointer;
}

.tabs {
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.record-filters {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.record-search,
.record-select {
  min-width: 0;
  height: 34px;
  border-radius: 8px;
  border: 1px solid #3f3f3f;
  background: #1f1f1f;
  color: #fff;
  padding: 0 10px;
}

.record-search {
  flex: 1;
  width: 100%;
}

.record-select {
  width: 150px;
  max-width: 100%;
}

.record-list {
  max-height: min(420px, 52vh);
  min-height: 0;
  overflow-y: auto;
}

.record-item {
  align-items: flex-start;
  gap: 10px;
}

.record-item > div:first-child {
  flex: 1;
  min-width: 0;
  word-break: break-word;
}

.record-item strong {
  flex-shrink: 0;
}

.record-empty,
.record-load-tip {
  text-align: center;
  color: #9d9d9d;
  font-size: 12px;
  padding: 10px 0;
}
</style>
